module.exports = __webpack_public_path__ + "img/add-to-library-icon.0d007e9e.svg";